import {useId} from "react";
import {Button} from "react-bootstrap";
import {Eye} from "react-bootstrap-icons";
import {useAppDispatch, useAppSelector} from "../../app/store";
import {toastError} from "../../app/slices/admin";
import {startPreview} from "../../app/slices/offCanvas/previewOffCanvas";
import {ADMIN_LANG} from "../../settings";

type PreviewButtonProps = {
    previewUrl?: string;
    label: string;
    className?: string;
    unavailableMessage?: string;
};

const PreviewButton = ({
    previewUrl,
    label,
    className = '',
    unavailableMessage = ADMIN_LANG.preview_unavailable,
}: PreviewButtonProps) => {
    const dispatch = useAppDispatch();
    const descriptionId = useId();
    const {isLoading} = useAppSelector((state) => state.previewOffCanvas);
    const isUnavailable = !previewUrl;
    const isDisabled = isUnavailable || isLoading;

    const handleClick = () => {
        if (isLoading) {
            return;
        }

        if (!previewUrl) {
            dispatch(toastError(unavailableMessage));
            return;
        }

        dispatch(startPreview(previewUrl));
    };

    return (
        <>
            <Button
                type="button"
                variant="link"
                className={`preview-button p-0 border-0 ${className}`}
                aria-label={label}
                aria-describedby={isUnavailable ? descriptionId : undefined}
                aria-disabled={isDisabled}
                aria-busy={isLoading || undefined}
                onClick={handleClick}
            >
                <Eye
                    aria-hidden="true"
                    className={`utility-icon ${isDisabled ? 'disabled' : ''}`}
                />
            </Button>
            {isUnavailable && (
                <span id={descriptionId} className="visually-hidden">
                    {unavailableMessage}
                </span>
            )}
        </>
    );
};

export default PreviewButton;
